import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import Loading from '../../components/Loading';
import ItemPendencias from '../../components/ItemPendencias';
import styled from 'styled-components';

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 28px 10px 28px;
  border-bottom: 1.5px solid #f0f0f0;
  background: #fafbfc;
  border-radius: 10px 10px 0 0;
`;

const Title = styled.h3`
  font-size: 1.35rem;
  font-weight: 600;
  color: #2a3b4d;
  margin: 0;
`;

const StyledLink = styled(Link)`
  background: #1890ff;
  color: #fff !important;
  border-radius: 6px;
  padding: 6px 18px;
  font-size: 0.98em;
  font-weight: 500;
  text-decoration: none;
  transition: background 0.2s;
  border: none;
  margin-left: 12px;
  &:hover {
    background: #1765ad;
    color: #fff !important;
    text-decoration: none;
  }
`;

class VerificacaoAutomatica extends React.Component {
  render() {
    const { item } = this.props;
    return (
      <div className="mb-3">
        <div className="card card-bg">
          <CardHeader>
            <Title>Verificação automática</Title>
            <StyledLink to={`/itens/historico/${item}`} className="">
              Todas as versões
            </StyledLink>
          </CardHeader>
          <div className="card-body">
            {item ? <ItemPendencias item_id={item} /> : <Loading />}
          </div>
        </div>
      </div>
    );
  }
}

VerificacaoAutomatica.propTypes = {
  item: PropTypes.number.isRequired,
};

export default withRouter(VerificacaoAutomatica);
